var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1E81F7",
    height: "40px",
    width: "40px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M339.478,0H139.13C93.098,0,55.652,37.446,55.652,83.478v278.261c0,22.483,8.976,42.88,23.479,57.904 c-14.056,8.88-23.479,24.449-23.479,42.27c0,27.619,22.468,50.087,50.087,50.087h233.739c64.445,0,116.87-52.424,116.87-116.87 V116.87C456.348,52.424,403.923,0,339.478,0z M339.478,478.609H105.739c-9.206,0-16.696-7.49-16.696-16.696 s7.49-16.696,16.696-16.696h33.391h200.348c27.619,0,50.087-22.468,50.087-50.087s-22.468-50.087-50.087-50.087H139.13 c-9.217,0-16.696,7.479-16.696,16.696s7.479,16.696,16.696,16.696h200.348c9.206,0,16.696,7.49,16.696,16.696 s-7.49,16.696-16.696,16.696H139.13c-27.619,0-50.087-22.468-50.087-50.087c0-27.619,22.468-50.087,50.087-50.087h200.348 c46.032,0,83.478,37.446,83.478,83.478S385.51,478.609,339.478,478.609z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowel);
export default __webpack_public_path__ + "static/media/towel.fb84c0b66a743d6aed6cc0706c2e3ea2.svg";
export { ForwardRef as ReactComponent };